export default __webpack_public_path__ + "static/media/sox.162f6352.jpg";